// ============================================================================
// resolveObjectName.ts — ЕДИНЫЙ резолв отображаемого имени (синонима) объекта
// метаданных по типу и коду: «counterparties» → «Контрагенты», «orders» →
// «Заявка» и т.п. (SSoT — сервер; кэширование результатов по ключу).
// Используется в заголовках форм выбора/пикеров (вместо транслит-кодов).
// ============================================================================

import { getSDK } from '@/store/sdkStore';

const cache = new Map<string, string>();

export async function resolveObjectSynonym(objectType: string, objectName: string): Promise<string> {
  const key = `${objectType}.${objectName}`;
  const cached = cache.get(key);
  if (cached) return cached;
  const sdk = getSDK();
  const t = (objectType || '').toLowerCase();
  let name = objectName;
  try {
    if (t === 'catalog') {
      const r: any = await sdk.metadata.listCatalogs({});
      const c = (r.items || []).find((x: any) => x.code === objectName);
      if (c) name = c.synonym || c.name || objectName;
    } else if (t === 'document') {
      const r: any = await sdk.metadata.listDocuments({});
      const d = (r.items || []).find((x: any) => x.code === objectName);
      if (d) name = d.synonym || d.name || objectName;
    } else if (t === 'register') {
      const r: any = await sdk.metadata.listRegisters({});
      const rg = (r.items || []).find((x: any) => x.code === objectName);
      if (rg) name = rg.synonym || rg.name || objectName;
    } else if (t === 'task') {
      const r: any = await sdk.task.listTaskTypes({});
      const tt = (r.items || []).find((x: any) => x.code === objectName);
      if (tt) name = tt.synonym || tt.name || objectName;
    } else if (t === 'order') {
      const r: any = await sdk.order.listOrderTypes({});
      const ot = (r.items || []).find((x: any) => x.code === objectName);
      if (ot) name = ot.synonym || ot.name || objectName;
    } else if (t === 'entity') {
      const r: any = await sdk.entity.listEntities({});
      const e = (r.items || []).find((x: any) => x.id === objectName || x.login === objectName);
      if (e) name = e.name || objectName;
    }
  } catch {
    return objectName;
  }
  cache.set(key, name);
  return name;
}
